import React from 'react';
import PropTypes from 'prop-types';

import { useApplicationState, useLabel } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { useQuickDepositPostHog } from 'hooks/usePostHog';
import { QUICK_DEPOSIT_POPUP_TITLE_TYPE } from 'src/common/constants';
import {
  checkDepositBonusTypeFits,
  getBonusMinDeposit,
  pickBonusWithLowestMinDeposit,
} from 'src/common/utils/depositBonusUtils';
import { useBonusesContext } from 'src/components/BonusesProvider';
import QuickDepositForm from 'src/components/QuickDepositPopup/QuickDepositForm';
import useSetRedirectUrl from 'src/hooks/useSetRedirectUrl';

const QuickDepositPopupContent = ({ afterDelay, onClose, onCloseClick }) => {
  const { wallet } = useApplicationState();
  const { currency } = wallet;

  const { bonusesList, selectedBonus } = useBonusesContext();

  const listBonus = pickBonusWithLowestMinDeposit(bonusesList, currency);

  const bonus = selectedBonus || listBonus;

  const bonusTypeValue = bonus?.bonus?.bonusType ?? bonus?.bonusType ?? bonus?.type;
  const minBonusAmount = getBonusMinDeposit(bonus, currency);
  const showSubtitle = checkDepositBonusTypeFits(bonusTypeValue) && minBonusAmount > 0;

  const subtitle = useLabel('quick_deposit_to_activate', {
    currency,
    minBonusAmount,
  });

  const {
    handleCloseClick,
    handleDepositLoaderShown,
    handleDepositRedirectSuccess,
    handleDepositStart,
    handleDepositSuccess,
  } = useQuickDepositPostHog({
    afterDelay,
    onCloseClick,
  });

  const setRedirectUrl = useSetRedirectUrl();

  return (
    <DefaultPopup
      className="quick-deposit"
      headerTitle="quick_deposit_header"
      headerTitleClass="quick-deposit-header"
      headerTitlePosition="left"
      onClose={handleCloseClick}
      postHeaderTitle={showSubtitle ? subtitle : null}
    >
      <QuickDepositForm
        closeQRCodeOnSuccess
        onClose={onClose}
        onDepositLoaderShown={handleDepositLoaderShown}
        onDepositRedirectSuccess={handleDepositRedirectSuccess}
        onDepositStart={handleDepositStart}
        onDepositSuccess={handleDepositSuccess}
        setRedirectUrl={setRedirectUrl}
        titleType={QUICK_DEPOSIT_POPUP_TITLE_TYPE.QUICK_DEPOSIT}
      />
    </DefaultPopup>
  );
};

QuickDepositPopupContent.propTypes = {
  afterDelay: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};
const QuickDepositPopup = props => {
  return <QuickDepositPopupContent {...props} />;
};

QuickDepositPopup.propTypes = QuickDepositPopupContent.propTypes;

export default QuickDepositPopup;
